/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Merge_Replace_LabelInputs */



/**
* | output |
* | --- |
* | "Merge/Replace Events" |
*
* @param {Marker_Import_Merge_Replace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_merge_replace_label = /** @type {((inputs?: Marker_Import_Merge_Replace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Merge_Replace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner/Remplacer les evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen/Ersetzen von Ereignissen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci/Sostituisci eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединение/замена событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar/Reemplazar eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并/替换事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの結合/置換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं को मर्ज/प्रतिस्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar/Substituir Eventos")
	return /** @type {LocalizedString} */ ("Merge/Replace Events")
});